import { ReactComponent as PersonIco } from "../Assets/person.svg";
import { ReactComponent as BookIco } from "../Assets/book.svg";
import { ReactComponent as LoyaltyProgramIcon } from "../Assets/payment.svg";
import { ReactComponent as TestIco } from "../Assets/test.svg";
import { ReactComponent as AssocitionIco } from "../Assets/assocition.svg";
import { ReactComponent as NotificationIco } from "../Assets/notification.svg";
import { ReactComponent as DocumentIcon } from "../../../general/constants/icons/documents.svg";

export const ProfileMenu = [
	{
		id: 0,
		name: "Профиль",
		path: "/lk/",
		Logo: PersonIco,
	},
	{
		id: 1,
		name: "Мои мероприятия",
		path: "/lk/events",
		Logo: BookIco,
	},
	{
		id: 5,
		name: "Программа лояльности",
		path: "/lk/loyaltyProgram",
		Logo: LoyaltyProgramIcon,
	},
	{
		id: 2,
		name: "Тесты",
		path: "/lk/tests",
		Logo: TestIco,
	},
	{
		id: 3,
		name: "Учебные материалы",
		path: "/lk/materials",
		Logo: NotificationIco,
	},
	{
		id: 4,
		name: "Ассоциация",
		path: "/lk/association",
		Logo: AssocitionIco,
	},
	// {
	// 	id: 4,
	// 	name: "Документы",
	// 	path: "/lk/documents",
	// 	Logo: DocumentIcon,
	// },
	{
		id: 5,
		name: "Уведомления",
		path: "/lk/notifications",
		Logo: NotificationIco,
	},
];

export default ProfileMenu;
